import React from "react";
import { StaticQuery, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Button from "./atoms/Button";
import CityCallButton from "./city-call-button";
import { monthNames } from "../helpers/all";

const steps = [
  {
    title: "Request a Free Consultation",
    description:
      "It only takes a few clicks to schedule a consultation with us and start the process. We'll evaluate your request and budget and use it to prepare a quote adapted to your needs.",
  },
  {
    title: "Fine Tune The Details",
    description:
      "Materials, location, design, time frame. We'll take everything into consideration and will setup a plan that will allow us to work with maximum efficiency in order to get you results you'll love.",
  },
  {
    title: "Time To Work",
    description:
      "With a plan, the required equipment, materials and with a team of roofing experts, we'll get to work to bring to life your perfect roof. We won't rest until you're fully satisfied with your results.",
  },
];

const padNumber = (n) => String(n).padStart(2, "0");

const nth = (d) => {
  if (d > 3 && d < 21) return "th";
  switch (d % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

const GetANewRoofSteps = ({ city }) => (
  <StaticQuery
    query={graphql`
      query {
        stepsImage: file(relativePath: { eq: "roofing_bg.jpg" }) {
          childImageSharp {
            gatsbyImageData(width: 800)
          }
        }
        offerImage: file(relativePath: { eq: "roofing_bg.jpg" }) {
          childImageSharp {
            gatsbyImageData(width: 1400)
          }
        }
      }
    `}
    render={(data) => {
      const expires = new Date();
      expires.setDate(expires.getDate() + 7);
      const expiresLabel =
        monthNames[expires.getUTCMonth() % 12] +
        " " +
        expires.getUTCDate() +
        nth(expires.getUTCDate());

      const stepsImg = getImage(data.stepsImage.childImageSharp);
      const offerImg = getImage(data.offerImage.childImageSharp);

      return (
        <section className="py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
              <div>
                <h2 className="text-3xl md:text-4xl font-display font-extrabold text-neutral-900 mb-10 leading-tight">
                  Get A New Roof In 3 Steps
                </h2>
                <ol className="space-y-8 list-none p-0">
                  {steps.map(({ title, description }, i) => (
                    <li key={i} className="flex items-start">
                      <div className="flex-shrink-0 w-10 h-10 rounded-full border border-neutral-300 flex items-center justify-center text-neutral-700 text-xs font-semibold mr-4">
                        {padNumber(i + 1)}
                      </div>
                      <div>
                        <h3 className="font-display font-bold text-lg text-neutral-900 mb-2">
                          {title}
                        </h3>
                        <p className="text-neutral-600 leading-relaxed">
                          {description}
                        </p>
                      </div>
                    </li>
                  ))}
                </ol>
                <div className="mt-8 flex flex-wrap items-center gap-4">
                  <Button color="red" size="big" to="/contact/">
                    Schedule a Free Consultation
                  </Button>
                  <CityCallButton city={city} />
                </div>
              </div>

              <div className="rounded-xl overflow-hidden bg-neutral-200 min-h-[300px] lg:min-h-[460px]">
                {stepsImg ? (
                  <GatsbyImage
                    image={stepsImg}
                    alt={`Roofing services${city ? ` in ${city}` : ""}`}
                    className="w-full h-full"
                  />
                ) : null}
              </div>
            </div>

            <div className="mt-12 rounded-2xl overflow-hidden relative bg-neutral-900">
              {offerImg ? (
                <GatsbyImage
                  image={offerImg}
                  alt="Full Roof Replacement Offer"
                  className="!absolute inset-0 w-full h-full"
                  style={{ position: "absolute" }}
                />
              ) : null}
              <div className="absolute inset-0 bg-gradient-to-r from-neutral-900/90 via-neutral-900/70 to-transparent" />
              <div className="relative px-8 py-12 md:px-12 md:py-16 max-w-xl">
                <h3 className="text-brand-600 font-display font-extrabold text-3xl md:text-4xl mb-2">
                  $500 OFF
                </h3>
                <h4 className="text-white font-display font-bold text-2xl md:text-3xl mb-4">
                  Full Roof Replacement
                </h4>
                <p className="text-neutral-200 text-sm md:text-base mb-6">
                  Plus 50% off gutters. Minimum 20 square roof. Cannot be
                  combined with other promotions. Expires {expiresLabel}.
                </p>
                <Button color="red" size="big" to="/contact/">
                  Claim Offer
                </Button>
              </div>
            </div>
          </div>
        </section>
      );
    }}
  />
);

export default GetANewRoofSteps;
